function FileZone({ id, label, hint, accept, file, onChange, required }) {
  return (
    <div className="rs-field">
      <label className="rs-label" htmlFor={id}>
        {label}
      </label>
      <div className={`rs-file-zone${file ? " rs-file-zone--active" : ""}`}>
        <input
          type="file"
          id={id}
          {...(accept ? { accept } : {})}
          onChange={(e) => onChange(e.target.files[0] || null)}
          required={required}
        />
        <div className="rs-file-zone__icon">{file ? "✓" : "↑"}</div>
        <p className="rs-file-zone__text">
          {file ? "Dosya seçildi" : "Dosya seçmek için tıklayın"}
        </p>
        <p className="rs-file-zone__hint">{hint}</p>
        {file && <p className="rs-file-zone__name">{file.name}</p>}
      </div>
    </div>
  );
}

export default FileZone;
